<template>
  <h2 class="heading02 mx-auto my-5 h2">{{ titleName }}</h2>
</template>

<script>
  export default {
    props: {
      titleName: {
        type: String,
        default: "default",
      },
    },
  };
</script>
<style scoped>
.heading02 {
	position: relative;
	font-size: 26px;
	text-align: center;
	border-bottom: 5px solid rgb(var(--v-theme-secondary));
	padding: 10px;
	width: 80%;
	max-width: 600px;
}

.heading02::after {
	content: '';
	position: absolute;
	bottom: -5px;
	left: 50%;
	transform: translateX(-50%);
	width: 120px;
	height: 5px;
	background-color: rgb(var(--v-theme-primary));;
}
</style>
